/**
 * 将生产环境的依赖打包为layer.zip
 */

import * as fs from 'fs'
import * as path from 'path'
import * as cp from 'child_process'
import * as os from 'os'
import archiver from 'archiver'
import { type LayerOptions } from '../index'

/**
 * 构建 layer.zip
 */
export function layer(options: LayerOptions) {
  if (!fs.existsSync(options.packageJson)) {
    throw new Error(`package.json not found: ${options.packageJson}`)
  }

  const tempDir = fs.mkdtempSync(path.join(fs.realpathSync(os.tmpdir()), 'tscf-layer-'))

  const layerDir = path.join(tempDir, 'layer')
  fs.mkdirSync(layerDir, { recursive: true })

  fs.copyFileSync(options.packageJson, path.join(layerDir, 'package.json'))

  console.log('Start installing production dependencies...')

  // 构建 npm install 命令
  const baseArgs = ['install', '--omit=dev', '--prefix', layerDir]
  const npmArgs = options.npmArgs || []
  const allArgs = [...baseArgs, ...npmArgs]

  console.log(`Running: npm ${allArgs.join(' ')}`)

  cp.execSync(`npm ${allArgs.join(' ')}`, {
    stdio: 'inherit'
  })

  console.log('Production dependencies installed.')
  console.log('Start creating layer zip...')

  const output = fs.createWriteStream(path.join(tempDir, 'layer.zip'))
  const archive = archiver('zip', {
    zlib: { level: 9 }
  })

  output.on('close', () => {
    console.log(`Layer zip created: ${(archive.pointer() / 1024 / 1024).toFixed(2)} MB.`)
  })

  archive.on('warning', (err) => {
    if (err.code === 'ENOENT') {
      console.warn(err)
    } else {
      throw err
    }
  })

  archive.on('error', (err) => {
    throw err
  })

  archive.pipe(output)
  archive.directory(path.join(layerDir, 'node_modules'), false)
  archive.finalize()

  console.log('Layer.zip created at:', path.join(tempDir, 'layer.zip'))
}
